import { defineComponent as _defineComponent } from 'vue';
import DeviceTree from '@blade-sxp/monitoring-center/pages/preview/components/device-tree.vue';
import VideoStream from '@blade-sxp/monitoring-center/pages/preview/components/video-stream.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        return { __sfc: true, DeviceTree, VideoStream };
    }
});
